import { ConnectComponent } from '../../_components/ConnectComponent'
import { VehiclesView } from './Vehicles.view'
import { VehiclesPresenter } from './Vehicles.presenter'

export const Vehicles = ConnectComponent(VehiclesView, VehiclesPresenter)
